import { useEffect, useState } from 'react';
import { isNil } from 'es-toolkit';

import { useUser } from '@/lib/auth/useUser';

import { usePublicCategoryFilter } from './usePublicCategoryFilter';

/**
 * 유저의 teacherSchoolInfo를 기반으로 필터 초기값을 자동 설정하는 훅
 *
 * - 한 번만 실행됨 (이미 설정되었거나 사용자가 직접 선택한 경우 실행 안 함)
 * - teacherSchoolInfo의 schoolTypeCode, schoolGradeCode를 필터에 반영
 */
export function useInitialFilterFromUserInfo() {
  const [hasInitUserInfo, setInitUserInfo] = useState(false);

  const { isAuthenticated, user } = useUser();
  const {
    initialized,
    selectedSchoolTypeName,
    handleSelectedSchoolType,
    handleSelectedGrades,
  } = usePublicCategoryFilter();

  useEffect(() => {
    // 이미 설정되면 더이상 동작을 시키지않는다
    if (hasInitUserInfo) return;

    // 초기화되지 않았거나 인증되지 않았으면 early return
    if (!initialized || !isAuthenticated) return;

    // 이미 선택된 학교 타입이 있으면 early return
    if (selectedSchoolTypeName) return;

    const teacherInfo = user?.teacherSchoolInfo;

    // teacherInfo가 없거나 schoolTypeCode가 없으면 early return
    if (!teacherInfo || isNil(teacherInfo.schoolTypeCode)) return;

    // 유저 정보 기반으로 필터 설정
    void handleSelectedSchoolType(teacherInfo.schoolTypeCode);

    if (teacherInfo.schoolGradeCode) {
      void handleSelectedGrades(teacherInfo.schoolGradeCode);
    }

    setInitUserInfo(true);
  }, [
    isAuthenticated,
    handleSelectedGrades,
    handleSelectedSchoolType,
    hasInitUserInfo,
    initialized,
    selectedSchoolTypeName,
    user,
  ]);
}
